import { useEffect, useState } from 'react'
import { useTranslations } from '@npco/common-utils-translations'
import {
  ButtonFill,
  ButtonLink,
  COLOR,
  Flex,
  Tutorial,
} from '@npco/zeller-design-system'
import { MainContentModal } from 'features/StartupModals/SetupFlow/SetupFlowModal/pages/TapToPayStage/TapToPayStage/MainContentModal'
import { getPreLoadImages } from 'features/StartupModals/TapToPayModal/TapToPayModal.utils'

import { useImagePreloader } from 'hooks/useImagePreloader/useImagePreloader'
import { translationsShared } from 'translations/index'

import { Illustration } from '../SetupFlow/components/Illustration/Illustration'
import * as styled from '../StartupModals.styled'
import { useTapToPayModal } from './hooks/useTapToPayModal'

export const LEARN_MORE_URL = 'https://www.myzeller.com/zeller-app/tap-to-pay'

export const TapToPayModal = ({
  shouldCloseOnEsc = false,
}: {
  shouldCloseOnEsc?: boolean
}) => {
  const tShared = useTranslations(translationsShared)
  const { shouldTapToPayModal, updateProductTourStatus } = useTapToPayModal()

  const [isOpen, setIsOpen] = useState(shouldTapToPayModal)

  const imageArray = getPreLoadImages()
  const { imagesPreloaded } = useImagePreloader(imageArray)

  useEffect(() => {
    updateProductTourStatus({ showTapToPayInstructions: false })
    // componentDidMount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!imagesPreloaded) {
    return null
  }

  return (
    <styled.CustomizedModal
      className="animated-content"
      closeTimeoutMS={350}
      isOpen={isOpen}
      // NOTE: onCancel should be optional when shouldCloseOnEsc
      // and shouldCloseOnOverlayClick are false
      onCancel={() => {
        setIsOpen(false)
      }}
      overlayClassName="animated-overlay"
      shouldCloseOnEsc={shouldCloseOnEsc}
      shouldCloseOnOverlayClick={false}
      shouldFocusAfterRender
    >
      <Tutorial.TutorialLayout
        Footer={
          <Flex
            justifyContent="space-between"
            width="100%"
            padding={{
              _: '12px 24px 24px',
              SM: '12px 32px 32px',
              LG: '12px 24px 0 0',
            }}
            backgroundColor={COLOR.WHITE}
          >
            <ButtonLink onClick={() => setIsOpen(false)}>
              {tShared('close')}
            </ButtonLink>
            <ButtonFill
              onClick={() => window.open(LEARN_MORE_URL, '_blank', 'noopener')}
            >
              {tShared('learnMore')}
            </ButtonFill>
          </Flex>
        }
        Illustration={
          <Illustration
            imageSmall={imageArray[0]}
            imageMedium={imageArray[1]}
            imageLarge={imageArray[2]}
          />
        }
        MainContent={<MainContentModal />}
      />
    </styled.CustomizedModal>
  )
}
